(() => {
    document.addEventListener('SubstrateCalculator_NewResult', () => {
        window.dataLayerPushDeferred({
            event: 'calculadora',
        });
    });

    document.addEventListener('SubstrateCalculator_ResetValues', () => {
        window.dataLayerPushDeferred({
            event: 'reset_calculadora',
        });
    });
})();
